export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11024.9c9526bf.jpg";